export const DEFAULT_UNCategorized_CATEGORY_ID = 456;

export const findCategoryInTree = (macroCategories, categoryId) => {
  const parsedId = Number(categoryId);
  if (!Number.isFinite(parsedId) || parsedId === DEFAULT_UNCategorized_CATEGORY_ID) {
    return null;
  }

  for (const macroItem of macroCategories || []) {
    if (Number(macroItem.macroId) === parsedId) {
      return {
        categoryId: parsedId,
        pathLabels: [macroItem.macro],
        macroId: macroItem.macroId,
      };
    }

    for (const microItem of macroItem.micros || []) {
      if (Number(microItem.microId) === parsedId) {
        return {
          categoryId: parsedId,
          pathLabels: microItem.pathLabels || [macroItem.macro, microItem.micro],
          macroId: macroItem.macroId,
        };
      }
    }
  }

  return null;
};

export const flattenCategoryNodes = (macroCategories) => {
  const nodes = [];
  (macroCategories || []).forEach((macroItem) => {
    nodes.push({
      type: "macro",
      label: macroItem.macro,
      categoryId: macroItem.macroId,
      pathLabels: [macroItem.macro],
      depth: 1,
    });
    (macroItem.micros || []).forEach((microItem) => {
      nodes.push({
        type: "micro",
        label: microItem.micro,
        macro: macroItem.macro,
        categoryId: microItem.microId,
        pathLabels: microItem.pathLabels || [macroItem.macro, microItem.micro],
        depth: microItem.depth || (microItem.pathLabels || []).length || 2,
      });
    });
  });
  return nodes;
};
